export default __webpack_public_path__ + "static/media/PROCESSMETHOD_CNC_MACHINING_CENTER.4c622634.png";